import NoBookFlow from "../../Types/NoBookFlow";
import BaseExperimentalFlowResolver from "./BaseExperimentalFlowResolver";
import ExperimentKey from "./ExperimentKey";
import NoConfirmationNoBookFlow from "./NoConfirmationNoBookFlow";

/** Resolves the no-confirmation no-book flow when the confirmation-page-removal experiment is active. */
class NoConfirmationNoBookFlowResolver extends BaseExperimentalFlowResolver {
  constructor(isCustomerPreQualified: boolean, experimentKey: ExperimentKey) {
    super(new NoConfirmationNoBookFlow(isCustomerPreQualified), new NoBookFlow(isCustomerPreQualified), experimentKey);
  }
}

export default NoConfirmationNoBookFlowResolver;
